import axios, {AxiosResponse} from 'axios'
import type {RushMindPerformanceBlock} from './RushMindSection'

const API_URL = process.env.REACT_APP_THEME_API_URL

// Bloco RushMind do dashboard do colaborador: score + cobranças do próprio usuário.
// Mesmo payload do campo `rushmind` de "Meu Desempenho", sem o cálculo pesado de performance.
export function getRushMindSummary(): Promise<RushMindPerformanceBlock> {
  return axios
    .get(`${API_URL}/api/rushmind/my-summary`)
    .then((res: AxiosResponse<{data: RushMindPerformanceBlock}>) => res.data.data)
}
